import type { ScenarioChatForm_Message } from './types'
import type * as GraphQLSchema from '@/types/schema.generated'
import { assertExhaustive } from '@/libs/utilities/assertExhaustive'

export function mapToScenarioChatMessageInputs(
  scenarioChatMessages: Record<string, ScenarioChatForm_Message>
): GraphQLSchema.ScenarioChatMessageInput[] {
  return Object.values(scenarioChatMessages).map(m => {
    const selectionsV2 = (():
      | GraphQLSchema.InputMaybe<GraphQLSchema.ScenarioChatMessageSelectionsInput>
      | undefined => {
      if (m.selections == null) {
        return undefined
      }

      switch (m.selections.type) {
        case 'BasicSelections':
          return {
            basicSelections: m.selections.basicSelections.map(s => {
              return {
                guid: s.guid,
                label: s.label,
                nextMessageIndex: s.nextScenarioChatMessageClientOnlyId
                  ? Object.values(scenarioChatMessages).findIndex(
                      m =>
                        m.clientOnlyId === s.nextScenarioChatMessageClientOnlyId
                    )
                  : undefined,
                actions: s.actions.map(a => {
                  switch (a.type) {
                    case 'AssignStaff':
                      return {
                        assignPlannerAccountToMatch: {
                          assignedStaffGUID: a.staffGUID,
                        },
                      }
                    default:
                      throw new Error(`unknown action type: ${a.type}`)
                  }
                }),
              }
            }),
          }
        case 'BookingRequestSelections':
          return {
            bookingRequestSelections: {
              // TODO: guid
              fallbackUrl:
                m.selections.fallbackUrl === ''
                  ? undefined
                  : m.selections.fallbackUrl,
            },
          }
        case 'None':
          return undefined
        default:
          assertExhaustive(m.selections)
      }
    })()

    return {
      guid: m.guid,
      body: m.body,
      selections: [],
      selectionsV2: selectionsV2,
    }
  })
}
